import Navbar from '../navigation/Navbar';
import Footer from '../../components/app/Footer';
import CustomSearchBar from '../utils/CustomSearchBar';
import { Typography } from '@mui/material';
import toList, { toHTML } from '../utils/ComponentUtil';
import { Link, useParams } from 'react-router-dom';
import CustomBreadcrumbs from '../utils/CustomBreadcrumbs';
import React, { useEffect, useState } from 'react';
import BlogsAPI from '../Apis/BlogsAPI';
import CustomTextField from '../utils/CustomTextField';
import CustomButton from '../utils/CustomButton';
import { Send } from '@mui/icons-material';
import Comments from '../utils/Comments';
import Header from '../utils/Header';
import ProfilePic from "../../images/Ellipse_170.png"
import BlogCard from './BlogCard';


function Blog() {
    const { blogId } = useParams();
    const [blog, setBlog] = useState({});
    const { data } = BlogsAPI.fetchBlogs();
    const blogs = data;
    const [inputText, setInputText] = useState('');
    const handleInputChange = (e) => {
        setInputText(e.target.value);
    }

    useEffect(() => {
        const blogContent = BlogsAPI.getBlogContent(blogId);
        setBlog(blogContent);
    }, [blogId]);

    function onSubmit(e) {
        e.preventDefault();
        blog?.comments.push({
            comment: inputText,
            user: {
                img: ProfilePic,
                name: 'Kaira'
            },
            date: new Date().toISOString().slice(0, 10),
            replies: []
        });
        setInputText('');
        setBlog({ ...blog });
    }

    const breadcrumbs = [toList([{ to: "/", child: "Home" }, { to: "/home", child: "Blogs" }], Link)
        , <Typography>{blog?.name}</Typography>]

    return (
        <>
            <Navbar selected='Help'/>
            <div className='wrapper'>
                <CustomBreadcrumbs breadcrumbs={breadcrumbs} />
                <CustomSearchBar to={'/blogs'} placeholder='Search Keyword'></CustomSearchBar>
                <div className='blog-content-wrp'>
                    <div className='blog-category'>{blog?.category}</div>
                    <img className='blog-title-img' src={blog?.titleImg} alt='blog-img' />
                    <div className='blog-title'>{blog?.name}</div>
                    <div className='profile-img-wrp'>
                        <img src={blog?.profilePic} alt='profile-img' />
                        <p>{blog?.userName}</p>
                    </div>
                    <div className='blog-wrp'>
                        {toHTML(blog?.content)}
                    </div>
                </div>
                <div className='add-comment-wrp'>
                    <form onSubmit={onSubmit}>
                        <CustomTextField onChange={handleInputChange} value={inputText} multiline={true} rows={2} placeholder='Add a comment'></CustomTextField>
                        <CustomButton onClick={onSubmit} name='Send' icon={<Send />}></CustomButton>
                    </form>
                    <Header title={'Comments(' + blog?.comments?.length + ')'} />
                </div>
                <div className='all-comments-wrp'><Comments data={blog?.comments} /></div>
                <div className='similar-jobs-wrp'>
                    <Header title='Similar Blogs' />
                    <div className='similar-jobs'>
                        <BlogCard {...blogs[0]} noDesc={true}></BlogCard>
                        <BlogCard {...blogs[1]} noDesc={true}></BlogCard>
                    </div>
                </div>
            </div>
            <Footer></Footer>
        </>
    );
}

export default Blog;